import type { CategoryStat } from "../../types";

interface StackedChartProps {
  categories: CategoryStat[];
  total: number;
}

function formatBaht(n: number) {
  return `฿${n.toLocaleString("en-US")}`;
}

export default function StackedChart({ categories, total }: StackedChartProps) {
  return (
    <div>
      <div className="text-[11px] mb-2 tracking-[0.08em] text-muted-foreground">
        total · {formatBaht(total)}
      </div>
      {/* Stacked bar */}
      <div className="flex h-9 rounded-[10px] overflow-hidden border border-border bg-card">
        {categories.map((cat) => (
          <div
            key={cat.category}
            title={`${cat.label}: ${formatBaht(cat.amount)} (${cat.percentage}%)`}
            className="flex items-center justify-center text-[10px] font-bold tracking-[0.04em] overflow-hidden text-[rgba(0,0,0,0.65)]"
            style={{
              width: `${cat.percentage}%`,
              background: cat.color,
              minWidth: cat.percentage > 12 ? undefined : 0,
            }}
          >
            {cat.percentage > 12 ? cat.label.split(" ")[0].toLowerCase() : ""}
          </div>
        ))}
      </div>
      {/* Legend */}
      <div className="flex flex-wrap gap-x-5 gap-y-2 mt-3.5">
        {categories.map((cat) => (
          <div key={cat.category} className="flex items-center gap-2.5">
            <span
              className="w-2.5 h-2.5 rounded-[3px] flex-shrink-0"
              style={{ background: cat.color }}
            />
            <span className="text-[12px] font-medium text-foreground">
              {cat.label.split(" ")[0]}
            </span>
            <span className="text-[11px] text-muted-foreground">
              {cat.percentage}%
            </span>
            <span className="text-[12px] font-bold tabular-nums text-foreground">
              {formatBaht(cat.amount)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
